import { createContext, useRef, type RefObject } from "react"
import { useNavigate, type NavigateFunction } from "react-router-dom"

const SharedNavigateContext = createContext<RefObject<NavigateFunction> | null>(
  null
)
const StableNavigateContext = SharedNavigateContext

interface StableNavigateContextProviderProps {
  children: React.ReactNode
}

const SharedNavigateContextProvider = ({
  children,
}: StableNavigateContextProviderProps) => {
  const navigate = useNavigate()
  const stableNavigate = useRef(navigate)

  return (
    <SharedNavigateContext.Provider value={stableNavigate}>
      {children}
    </SharedNavigateContext.Provider>
  )
}
const StableNavigateContextProvider = SharedNavigateContextProvider

export {
  SharedNavigateContext,
  SharedNavigateContextProvider,
  StableNavigateContext,
  StableNavigateContextProvider,
}
